import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function FinalPushSection() {
  return <section className="py-20 px-4 bg-[#0a0a0a] border-t border-white/5" data-id="element-81">
      <div className="max-w-5xl mx-auto" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-83">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-84">
            ¿Dónde estarás en 7 días?
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-85">
            El tiempo va a pasar de todos modos. La única diferencia es cómo te
            sentirás cuando termine la semana.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-86">
          {/* Option A: Inaction */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#111] p-8 rounded-2xl border border-gray-800 opacity-70 hover:opacity-100 transition-opacity" data-id="element-87">
            <div className="flex items-center gap-3 mb-6" data-id="element-88">
              <div className="p-2 bg-gray-800 rounded-lg text-gray-400" data-id="element-89">
                <X size={24} data-id="element-90" />
              </div>
              <h3 className="font-display text-2xl font-bold text-gray-300" data-id="element-91">
                Si no haces nada
              </h3>
            </div>
            <ul className="space-y-4 text-gray-400" data-id="element-92">
              <li className="flex gap-3" data-id="element-93">
                <span className="text-gray-600" data-id="element-94">•</span>
                Seguirás sintiendo esa presión en el pecho cada vez que piensas
                en dinero.
              </li>
              <li className="flex gap-3" data-id="element-95">
                <span className="text-gray-600" data-id="element-96">•</span>
                Verás a otros "menos preparados que tú" haciendo ventas online.
              </li>
              <li className="flex gap-3" data-id="element-97">
                <span className="text-gray-600" data-id="element-98">•</span>
                Perderás otra semana esperando el "momento perfecto" que nunca
                llega.
              </li>
            </ul>
          </motion.div>

          {/* Option B: Action */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-brand-surface p-8 rounded-2xl border border-brand-yellow/30 shadow-[0_0_30px_rgba(234,179,8,0.1)] relative overflow-hidden" data-id="element-99">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-yellow/10 blur-3xl rounded-full -mr-10 -mt-10" data-id="element-100"></div>

            <div className="flex items-center gap-3 mb-6 relative z-10" data-id="element-101">
              <div className="p-2 bg-brand-yellow text-black rounded-lg" data-id="element-102">
                <Check size={24} strokeWidth={3} data-id="element-103" />
              </div>
              <h3 className="font-display text-2xl font-bold text-white" data-id="element-104">
                Si empiezas hoy
              </h3>
            </div>
            <ul className="space-y-4 text-gray-200 relative z-10" data-id="element-105">
              <li className="flex gap-3" data-id="element-106">
                <Check className="text-brand-yellow shrink-0 mt-1" size={16} data-id="element-107" />
                <span data-id="element-108">
                  Tendrás tu sistema montado y funcionando en automático.
                </span>
              </li>
              <li className="flex gap-3" data-id="element-109">
                <Check className="text-brand-yellow shrink-0 mt-1" size={16} data-id="element-110" />
                <span data-id="element-111">
                  Habrás lanzado tu primera oferta al mundo sin miedo.
                </span>
              </li>
              <li className="flex gap-3" data-id="element-112">
                <Check className="text-brand-yellow shrink-0 mt-1" size={16} data-id="element-113" />
                <span data-id="element-114">
                  Podrías estar celebrando tu primera venta (y la sensación de
                  "sí se puede").
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}